import { observer } from 'mobx-react';
import { FC, ReactElement, useMemo } from 'react';
import { useOrderStoreContext } from '../../context';
import OrderCancelButton from './components/OrderCancelButton/OrderCancelButton';
import OrderNotes from './components/OrderNotes/OrderNotes';
import ResendSMS from './components/ResendSMS/ResendSMS';
import { OrderProducts } from './containers/OrderProducts/OrderProducts';
import { OrderTotal } from './containers/OrderTotal/OrderTotal';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import Permission from 'src/view/components/Permission/Permission';
import AggregatorManager from 'src/view/components/AggregatorManager/AggregatorManager';
import { USER_PERMISSIONS } from 'src/constants/user';
import { ORDER_STATUS } from 'src/constants/order';
import './style.scss';
import OrderCompleteButton from '~/view/screens/OrderScreen/containers/OrderMain/components/OrderCompleteButton/OrderCompleteButton';
import { DELIVERY_TYPE } from '~/constants/deliveryTypes';

export const OrderMain: FC = observer((): ReactElement => {
  const { store: orderStore } = useOrderStoreContext();

  const showResendSMS = useMemo((): boolean => {
    return Boolean(!orderStore.loading && orderStore.order?.sms && orderStore.order?.order_status_code === ORDER_STATUS.WAITING_FOR_PAYMENT);
  }, [orderStore.loading, orderStore.order]);

  const showCancelButton = useMemo((): boolean => {
    return Boolean(orderStore.order && [ORDER_STATUS.WAITING_FOR_PAYMENT, ORDER_STATUS.ON_HOLD].includes(orderStore.order?.order_status_code));
  }, [orderStore.order]);

  const showCompleteButton = useMemo((): boolean => {
    return Boolean(orderStore.order && [ORDER_STATUS.RETURNED].includes(orderStore.order?.order_status_code));
  }, [orderStore.order]);

  return (
    <div className="order-main">
      <OrderProducts />

      <div className="order-main__container">
        <ScrollableBlock>
          <OrderTotal />
          <OrderNotes notes={orderStore.order?.notes} loading={orderStore.loading} />
          {showResendSMS ? <ResendSMS /> : null}
        </ScrollableBlock>

        <AggregatorManager
          aggregator={orderStore.order?.aggregator_key}
          sectionName="statusManagment"
          currentStatus={orderStore.order?.order_status_code}
          nextStatus={ORDER_STATUS.CANCELED}
          deliveryType={orderStore.order?.delivery_type_code}
        >
          <Permission permissions={USER_PERMISSIONS.ORDERS_CANCEL}>{showCompleteButton ? <OrderCompleteButton /> : null}</Permission>

          <Permission permissions={USER_PERMISSIONS.ORDERS_CANCEL}>{showCancelButton ? null : <OrderCancelButton />}</Permission>
        </AggregatorManager>
      </div>
    </div>
  );
});
